module.exports = __webpack_public_path__ + "img/keyboard_D.113cb2a1.png";